import axios from 'axios'
import { Student, CreateStudentRequest, UpdateStudentRequest } from '../types'

const API_BASE_URL = import.meta.env.VITE_API_URL || '/api'

const api = axios.create({
  baseURL: API_BASE_URL,
})

// Add token to requests if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

interface StudentsResponse {
  success: boolean
  data: Student[]
  pagination: {
    currentPage: number
    totalPages: number
    totalItems: number
    itemsPerPage: number
  }
}

interface StudentResponse {
  success: boolean
  data: Student
}

export const getStudents = async (): Promise<StudentsResponse> => {
  const response = await api.get('/students')
  return response.data
}

export const getStudent = async (id: string): Promise<StudentResponse> => {
  const response = await api.get(`/students/${id}`)
  return response.data
}

export const createStudent = async (
  studentData: CreateStudentRequest,
): Promise<StudentResponse> => {
  const response = await api.post('/students', studentData)
  return response.data
}

export const updateStudent = async (
  id: string,
  studentData: UpdateStudentRequest,
): Promise<StudentResponse> => {
  const response = await api.put(`/students/${id}`, studentData)
  return response.data
}

export const deleteStudent = async (
  id: string,
): Promise<{ success: boolean; message: string }> => {
  const response = await api.delete(`/students/${id}`)
  return response.data
}

interface BulkImportResponse {
  success: boolean
  message: string
  data: {
    successful: number
    duplicates: number
    failed: number
    errors: Array<{ index: number; error: string; student: any }>
  }
}

export const bulkImportStudents = async (
  students: CreateStudentRequest[],
): Promise<BulkImportResponse> => {
  const response = await api.post('/students/bulk-import', { students })
  return response.data
}
